import React from "react";
import { Image, Modal } from "react-bootstrap";

const PreviewImageModal = ({ image, closeModal }) => {
  return (
    <Modal
      centered
      show={true}
      onHide={closeModal}
      size="md"
      className="react-survey-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Image Preview</Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex justify-content-center align-items-center h-100 ">
        <div className="image-preview-modal">
          <Image
            src={image}
            alt="image preview"
            width={300}
            height={300}
            className="object-fit-contain"
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PreviewImageModal;
